import { render, staticRenderFns } from "./FileViewer.vue?vue&type=template&id=3da8014f&scoped=true"
import script from "./FileViewer.vue?vue&type=script&lang=js"
export * from "./FileViewer.vue?vue&type=script&lang=js"
import "./FileViewer.vue?vue&type=style&index=0&id=3da8014f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da8014f",
  null
  
)

export default component.exports